import React from 'react'
import {ReviewItem} from '../../../@types'
import {ReviewAuthor} from './ReviewAuthor'
import {ReviewStars} from './ReviewStars'

type Props = {
  item: ReviewItem
  collapsedHeight: number
  expandedHeight: number
  collapsedComment: string
  isExpanded: boolean
  onToggle: () => void
  contentRef: (element: HTMLDivElement | null) => void
}

const ReviewCardDashboard = ({
  item,
  collapsedHeight,
  expandedHeight,
  collapsedComment,
  isExpanded,
  onToggle,
  contentRef,
}: Props) => (
  <div
    className='bg-white'
    style={{
      borderRadius: 18,
      minHeight: 240,
      maxHeight: isExpanded ? expandedHeight : collapsedHeight,
      overflow: 'hidden',
      border: '1px solid #ece9e2',
      transition: 'max-height 450ms cubic-bezier(0.22, 1, 0.36, 1)',
    }}
  >
    <div ref={contentRef} className='p-5 d-flex flex-column h-100'>
      <div className='d-flex justify-content-between align-items-start'>
        <ReviewAuthor
          authorName={item.author_name}
          reviewDate={item.review_date}
          locale='en-GB'
          avatarWrapperClassName='symbol symbol-circle symbol-40px me-4'
          avatarLabelClassName='symbol-label fs-4 fw-bolder bg-light-primary text-primary'
          titleClassName='text-gray-900 fw-bolder fs-5'
          dateClassName='text-muted fw-semibold fs-8'
        />
      </div>

      <ReviewStars rating={Number(item.rating)} iconClassName='fs-6' wrapperClassName='d-flex align-items-center gap-1 my-4' />

      <div className='text-gray-700 fw-semibold fs-7 flex-grow-1'>
        <div style={{overflow: 'hidden'}}>{isExpanded ? item.comment : collapsedComment}</div>
      </div>

      <button
        type='button'
        className='btn btn-link p-0 text-gray-500 fw-semibold fs-8 mt-3 align-self-start'
        onClick={onToggle}
      >
        {isExpanded ? 'Lire moins' : 'En savoir plus'}
      </button>
    </div>
  </div>
)

export {ReviewCardDashboard}
